import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RootRoute = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      try {
        const parsedUser = JSON.parse(user);
        switch (parsedUser.role) {
          case 'Head Office Admin':
            navigate('/admin/dashboard');
            break;
          case 'Regional Manager':
            navigate('/coordinator/dashboard');
            break;
          case 'Content Editor':
            navigate('/editor/dashboard');
            break;
          case 'Content Reviewer':
            navigate('/approver/dashboard');
            break;
          case 'Trainer':
            navigate('/branch/dashboard');
            break;
          default:
            navigate('/login');
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
        navigate('/login');
      }
    } else {
      navigate('/login');
    }
  }, [navigate]);

  return null;
};

export default RootRoute;